export class ConferencePattern {
    constructor(id: number) {
        this.pbxId = id;
    }

    name: string = '';
    pbxId: number;
    type = 'CONFERENCE';
}
